<template>
  <v-app id="inspire">
    <!-- ナビ -->
    <Navbar
      :show-nav-demand="true"
      :show-nav-store="true"
    />

    <!-- メインコンテンツ -->
    <v-main class="contents">
      <RouterView/>
    </v-main>

    <!-- フッター -->
    <Footer/>

    <!-- 共通モーダル -->
    <Modal></Modal>

    <!-- 画面ローダー -->
    <Loader></Loader>
  </v-app>
</template>

<script>
import {mapGetters} from "vuex";
import Navbar from './parts/Navbar.vue'
import Footer from './parts/Footer.vue'
import Modal from "../utility/Modal";
import Loader from "../utility/Loader";

export default {
  components: {
    Navbar,
    Footer,
    Modal,
    Loader
  },
  computed: {
    ...mapGetters({
      isLogin: 'auth/check'
    })
  },
}
</script>
